import type { AudioCachePort } from "../../ports/audio-cache.port";
import { createBlobCache } from "./blob-cache";

const store = createBlobCache("studyhub-app-media-v1", "audio");

export const audioCacheWebAdapter: AudioCachePort = {
	get: store.get,
	put: store.put,
	evict: store.evict,
	size: store.size,
	keys: store.keys,
	sizeBytes: store.sizeBytes,
	meta: store.meta,
};
